module.exports = __webpack_public_path__ + "img/20200327142228913.59e25512.png";